import { IMaterials, IPaginationResponse } from "../types";
import {
  IProxyEvent,
  IProxyEventMaterialsParams,
  IProxyEventParams,
  IProxyEventProposalsParams,
  IProxyEventDateStatsParams,
  IProxyEventsParams,
  IProposal,
  ProxyEventDateStats,
  IProxyEventAdditionalMailingForGraph,
  IProxyEventVoteSolicitationForGraph,
  IProxyEventAdditionalMailingsParams,
  IProxyEventVoteSolicitationsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const proxyEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    proxyEvents: builder.query<
      IPaginationResponse<IProxyEvent>,
      IProxyEventsParams
    >({
      query: ({ limit, ordering, offset, tab, types, issuerId }) => ({
        url: `proxy-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          types: types || undefined,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["proxyEvents"],
    }),
    proxyEvent: builder.query<IProxyEvent, IProxyEventParams>({
      query: ({ id }) => ({
        url: `proxy-events/${id}/`,
      }),
      providesTags: (_result, _, arg) => [{ type: "proxyEvents", id: arg.id }],
    }),
    proxyEventMaterials: builder.query<
      IMaterials[],
      IProxyEventMaterialsParams
    >({
      query: ({ id }) => ({
        url: `proxy-events/${id}/documents/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "proxyEventMaterials", id: arg.id },
      ],
    }),
    proxyEventProposals: builder.query<IProposal[], IProxyEventProposalsParams>(
      {
        query: ({ id }) => ({
          url: `proxy-events/${id}/proposals/`,
        }),
        providesTags: (_result, _, arg) => [
          { type: "proxyEventProposals", id: arg.id },
        ],
      }
    ),
    proxyEventDateStats: builder.query<
      ProxyEventDateStats[],
      IProxyEventDateStatsParams
    >({
      query: ({ id }) => ({
        url: `proxy-events/${id}/date-stats/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "proxyEventDateStats", id: arg.id },
      ],
    }),
    proxyEventsWithChangeRequest: builder.query<
      IPaginationResponse<IProxyEvent>,
      IProxyEventsParams
    >({
      query: ({
        limit,
        ordering,
        offset,
        changeRequestStatus,
        types,
        issuerId,
      }) => ({
        url: `proxy-events/`,
        params: {
          limit,
          ordering,
          offset,
          changeRequestStatus,
          types: types || undefined,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["proxyEvents"],
    }),
    proxyEventAdditionalMailings: builder.query<
      IProxyEventAdditionalMailingForGraph[],
      IProxyEventAdditionalMailingsParams
    >({
      query: ({ id }) => ({
        url: `proxy-events/${id}/additional-mailings/`,
        params: {
          operations_status: "approved",
        },
      }),
      providesTags: (_result, _, arg) => [
        { type: "proxyEventAdditionalMailings", id: arg.id },
      ],
    }),
    proxyEventVoteSolicitations: builder.query<
      IProxyEventVoteSolicitationForGraph[],
      IProxyEventVoteSolicitationsParams
    >({
      query: ({ id }) => ({
        url: `proxy-events/${id}/vote-solicitations/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "proxyEventVoteSolicitations", id: arg.id },
      ],
    }),
  }),
});

export const {
  useProxyEventQuery,
  useProxyEventsQuery,
  useProxyEventMaterialsQuery,
  useProxyEventProposalsQuery,
  useProxyEventDateStatsQuery,
  useProxyEventsWithChangeRequestQuery,
  useProxyEventAdditionalMailingsQuery,
  useProxyEventVoteSolicitationsQuery,
} = proxyEventApis;
